import { gql } from "apollo-boost";

export default gql `
query MyQuery($search:String, $offset: Int, $limit: Int, $section: [String] = ["blog", "contact", "leadershipBio", "news", "pages"]) {
    entries(search: $search, limit: $limit, offset: $offset, orderBy: "score", section: $section) {
      id
      ... on pages_page_Entry {
        id
        title
        uri
        pageBuilder {
          ... on pageBuilder_header_BlockType {
            id
            heading
          }
        }
      }
      ... on blog_blog_Entry {
        id
        title
        uri
        blogBuilderMatrix {
          ... on blogBuilderMatrix_blogRichText_BlockType {
            id
            richText
          }
        }
      }
      ... on blog_externalPost_Entry {
        id
        title
        externalUrl {
          type
          url
        }
      }
      ... on leadershipBio_leadershipBio_Entry {
        id
        title
        uri
        bioPageSwitch
        blogPostRichText
        positionTitle
      }
      ... on contact_contact_Entry {
        id
        heading
        title
        uri
      }
      ... on news_news_Entry {
        id
        heading
        uri
        title
      }
    }
    entryCount(search: $search, section: $section)
  }

`;